// https://apps.dtic.mil/sti/pdfs/ADA443657.pdf

function pertubation (options) {
    // Identifiers
    let RT, RHO_P, RHO_T, YP, VI, VR, UP, LO, LI, P, PD, T, LAMDA, TAU,
        MHU, BETA, ALPHA, EPSI, V0, U0, LAMDA0, PD0, V1, U1, LAMDA1, PD1, V2,
        U2, LAMDA2, PD2, V, U, C0, C1, C2, C3, V3, U3, PD3, LAMDA3, THK, A, B;
    let ORDER;
    let timestep = 0.000001;

    // Input values for velocity, length, and material constants
    VI = options.impactVelocity // m/s
    LO = options.originalLength // m
    RHO_P = options.densityPenetrator // kg/m^3
    RHO_T = options.densityTarget // kg/m^3
    YP = options.flowStressPenetrator // Pa
    RT = options.strengthResistanceTarget // Pa

    // Check for data inconsistencies
    if (RT === YP) {
        console.error("*****RT must not equal YP for a meaningful perturbation solution.*****");
        return;
    }

    THK = options.targetThickness
    if (!THK) {
        THK = 1;
    }

    ORDER = options.order || 1;

    // Normalization scheme
    MHU = Math.sqrt(RHO_T / RHO_P);
    BETA = MHU / (1.0 + MHU) * VI / LO;
    ALPHA = (RT - YP) / YP;
    EPSI = YP / (RHO_P * VI ** 2);
    A = (1.0 + MHU) / MHU;
    B = 1.0 - ALPHA / MHU;
    T = 0.0;

    // Main calculation loop
    while (true) {
        TAU = BETA * T;

        // Zero order calculation resulting from perturbation analysis
        V0 = 1.0;
        U0 = 1.0 / (1.0 + MHU);
        LAMDA0 = 1.0 - TAU;
        PD0 = TAU / MHU;

        // First order calculation resulting from perturbation analysis
        V1 = ((1.0 + MHU) / MHU) * Math.log(1.0 - TAU);
        U1 = (1.0 / MHU) * (Math.log(1.0 - TAU) - ALPHA);
        LAMDA1 = ((1.0 + MHU) / MHU) * ((1.0 - ALPHA / MHU) * TAU + (1.0 - TAU) * Math.log(1.0 - TAU));
        PD1 = -(1.0 + MHU) / (MHU ** 2) * (TAU * (ALPHA + 1.0) + (1.0 - TAU) * Math.log(1.0 - TAU));

        // Second order calculation resulting from perturbation analysis
        V2 = ((1.0 + MHU) / MHU) ** 2 * (1.0 - ALPHA / MHU) * (Math.log(1.0 - TAU) + 1 / (1.0 - TAU) - 1.0) - 
             0.5 * (((1.0 + MHU) / MHU) ** 2) * (Math.log(1.0 - TAU)) ** 2;
        U2 = V2 / (1.0 + MHU) + (ALPHA / MHU ** 2) * (1.0 + MHU) * Math.log(1.0 - TAU) + 
             (ALPHA ** 2) * (1.0 - MHU ** 2) / (2.0 * MHU ** 3);
        C0 = 3.0 - 3.0 * ALPHA / MHU + ALPHA ** 2 / (2.0 * MHU ** 2) - ALPHA ** 2 / (2.0 * MHU);
        LAMDA2 = ((1.0 + MHU) / MHU) ** 2 * (-(3.0 - 3.0 * ALPHA / MHU + ALPHA ** 2 / (2.0 * MHU ** 2) - 
                 ALPHA ** 2 / (2.0 * MHU)) * (1 - TAU) + (1.0 - ALPHA / MHU) * Math.log(1.0 - TAU) + 
                 2.0 * (1.0 - ALPHA / MHU) * (1.0 - TAU) * Math.log(1.0 - TAU) - 
                 0.5 * (1.0 - TAU) * (Math.log(1.0 - TAU)) ** 2 + C0);
        PD2 = (1.0 + MHU) ** 2 / MHU ** 3 * (B * (1.0 - 2.0 * TAU - (1.0 - TAU) * Math.log(1.0 - TAU) - 
              Math.log(1.0 - TAU)) + (1.0 - TAU) / 2.0 * (Math.log(1.0 - TAU)) ** 2 - (1.0 - TAU) * 
              Math.log(1.0 - TAU) + 1.0 - TAU + ALPHA * (1.0 - TAU - (1.0 - TAU) * Math.log(1.0 - TAU)) + 
              ALPHA ** 2 * (1.0 - MHU) * TAU / (2.0 * MHU) - (2 + ALPHA - ALPHA / MHU));

        // Third order calculation resulting from perturbation analysis
        C1 = -3.0 / 2.0 * B ** 2 - 2.0 * B + ALPHA ** 2 / (2.0 * MHU) * (1.0 - 1.0 / MHU);
        V3 = A ** 3 * ((4.0 - 5.0 * ALPHA / MHU - ALPHA ** 2 / (2.0 * MHU) + 
              3.0 * ALPHA ** 2 / (2.0 * MHU ** 2)) * Math.log(1.0 - TAU) - 
              0.5 * B ** 2 * 1.0 / (1.0 - TAU) ** 2 + (2.0 * B + 2.0 * B ** 2 - 
              ALPHA ** 2 / (2.0 * MHU) + ALPHA ** 2 / (2.0 * MHU ** 2)) * 
              1.0 / (1.0 - TAU) - 2.0 * B * (Math.log(1.0 - TAU)) ** 2 + 0.5 * 
              (Math.log(1.0 - TAU)) ** 3 - B * (Math.log(1.0 - TAU)) / (1.0 - TAU) + C1);
        U3 = (V3 * (V0 - U0) + (V1 - U1) * (V2 - U2) - MHU ** 2 * U1 * U2) / ((V0 - U0) + U0 * MHU ** 2);
        C2 = (1.0 + MHU) ** 3 / MHU ** 4 * (-4.0 - 7.0 / 2.0 * B ** 2 - 7.0 * B + 9.0 / 2.0 * ALPHA ** 2 / MHU - 
              5.0 * ALPHA - 3.0 * ALPHA ** 2 / 2.0 - ALPHA ** 3 / (2.0 * MHU ** 2) * 
              (1.0 - MHU) ** 2 + B ** 2 / 2.0);
        PD3 = (-(1.0 + MHU)) ** 3 / MHU ** 4 * ((1.0 - TAU) * (-4.0 - 7.0 / 2.0 * B ** 2 - 7.0 * B + 
               9.0 / 2.0 * ALPHA ** 2 / MHU - 5.0 * ALPHA - 3.0 * ALPHA ** 2 / 2.0 - 
               ALPHA ** 3 * (1.0 - MHU) ** 2 / (2.0 * MHU ** 2)) + (1.0 - TAU) * 
               Math.log(1.0 - TAU) * (7.0 / 2.0 + 6.0 * B + 3.0 * ALPHA * B + 3.0 * B ** 2 / 2.0 + 
               ALPHA + 3.0 * ALPHA ** 2 / 2.0) + B ** 2 / (2.0 * (1.0 - TAU)) + 
               (B + 5.0 / 2.0 * B ** 2 + ALPHA - 3.0 * ALPHA ** 2 / (2.0 * MHU) + 1.0 / 2.0) * 
               Math.log(1.0 - TAU) + (1.0 - TAU) * (Math.log(1.0 - TAU)) ** 2 * (-2.0 * B - 3.0 / 2.0 * 
               (1.0 + ALPHA)) - B / 2.0 * (Math.log(1.0 - TAU)) ** 2 + (1.0 - TAU) / 2.0 * 
               (Math.log(1.0 - TAU)) ** 3) + C2;
        C3 = ((1 + MHU) / MHU) ** 3 * (5.0 / 2.0 + 13.0 / 2.0 * B ** 2 + 5.0 * B - 
              5.0 * ALPHA ** 2 / (2.0 * MHU) - ALPHA ** 3 / (2.0 * MHU ** 3) * 
              (MHU - 1) ** 2);
        LAMDA3 = ((1 + MHU) / MHU) ** 3 * ((-7.0 * B / 2.0) * (1.0 - TAU) * 
                 (Math.log(1.0 - TAU)) ** 2 + (7.0 * B ** 2 / 2.0 - ALPHA ** 2 / (2.0 * MHU) + 
                 1.0 / 2.0) * Math.log(1.0 - TAU) - B / 2.0 * (Math.log(1.0 - TAU)) ** 2 + 
                 (2.0 + 5.0 * B + 4 * B ** 2 - 2 * ALPHA ** 2 / MHU) * (1.0 - TAU) * 
                 Math.log(1.0 - TAU) + (-5.0 / 2.0 - 7.0 * B ** 2 - 5.0 * B + 
                 5.0 * ALPHA ** 2 / (2.0 * MHU) + ALPHA ** 3 / (2.0 * MHU ** 3) * 
                 (MHU - 1) ** 2) * (1.0 - TAU) + B ** 2 / (2.0 * (1.0 - TAU)) + 
                 (1.0 - TAU) / 2.0 * (Math.log(1.0 - TAU)) ** 3) + C3;

        // Summation of series for 1st order, 2nd order, and 3rd order perturbation solution
        if (ORDER === 1) {
            V = V0 + EPSI * V1;
            U = U0 + EPSI * U1;
            LAMDA = LAMDA0 + EPSI * LAMDA1;
            PD = PD0 + EPSI * PD1;
        } else if (ORDER === 2) {
            V = V0 + EPSI * V1 + (EPSI ** 2) * V2;
            U = U0 + EPSI * U1 + (EPSI ** 2) * U2;
            LAMDA = LAMDA0 + EPSI * LAMDA1 + (EPSI ** 2) * LAMDA2;
            PD = PD0 + EPSI * PD1 + (EPSI ** 2) * PD2;
        } else if (ORDER === 3) {
            V = V0 + EPSI * V1 + (EPSI ** 2) * V2 + (EPSI ** 3) * V3;
            U = U0 + EPSI * U1 + (EPSI ** 2) * U2 + (EPSI ** 3) * U3;
            LAMDA = LAMDA0 + EPSI * LAMDA1 + (EPSI ** 2) * LAMDA2 + (EPSI ** 3) * LAMDA3;
            PD = PD0 + EPSI * PD1 + (EPSI ** 2) * PD2 + (EPSI ** 3) * PD3;
        }

        // Converting normalized values into actual values
        VR = V * VI;
        UP = U * VI;
        P = PD * LO;
        LI = LAMDA * LO;

        // Penetration process stop conditions
        if (RT > YP && VR <= Math.sqrt(2.0 * (RT - YP) / RHO_P)) {
            if (options.debug) console.log('bounce')
            break;
        }
        if (RT < YP && VR <= Math.sqrt(2.0 * (YP - RT) / RHO_T)) {
            if (options.debug) console.log('rigid body rod')
            break;
        }
        if (P > THK) break;
        if (LI < 0.0 || isNaN(LI)) break;
        if (T > .5) break;

        // Output data for graphical processing (using console.log for simplicity)
        if (options.debug) {
            console.log(`Time: ${T.toFixed(7)}, Rod Velocity: ${VR.toFixed(10)}, Penetration Velocity: ${UP.toFixed(10)}, Penetration Depth: ${P.toFixed(8)}, Length: ${LI.toFixed(8)}`);
        }

        // Time increment, 1 microsecond step size
        T += timestep
    }

    return P
}

const rodMaterials = {
    forrestalPenetratorSteel: {
        density: 8000,
        flowStress: 1.38e9,
    },
    tungsten: {
        density: 17600,
        flowStress: 1e9,
    },
    tungsten93: {
        density: 17600,
        flowStress: 3.6e9,
    },
    depletedUranium: {
        density: 18600,
        flowStress: 3.2e9,
    },
}

const targetMaterials = {
    steelRHA: {
        density: 7800,
        resistance: 5.5e9,
    },
}

export default function calculatePenetrationDepth(fps, lengthInches, rodMaterial = 'tungsten93') {
    const impactVelocity = fps * 0.3048;
    const originalLength = lengthInches * 0.0254;
    const penetrationMeters = pertubation({
        impactVelocity,
        originalLength,
        densityPenetrator: rodMaterials[rodMaterial].density,
        flowStressPenetrator: rodMaterials[rodMaterial].flowStress,
        densityTarget: targetMaterials.steelRHA.density,
        strengthResistanceTarget: targetMaterials.steelRHA.resistance,
    })
    const penetrationInches = penetrationMeters > 0 ? penetrationMeters * 39.3701 : 0
    return penetrationInches
}

//console.log(calculatePenetrationDepth(3000, 1, 'tungsten'), 'inches tungsten')
//console.log(calculatePenetrationDepth(3000, 1, 'tungsten93'), 'inches tungsten93')
//console.log(calculatePenetrationDepth(3000, 1, 'depletedUranium'), 'inches depletedUranium')
//console.log(calculatePenetrationDepth(3000, 1, 'forrestalPenetratorSteel'), 'inches forrestalPenetratorSteel')
//console.log(calculatePenetrationDepth(4000, 1.65, 'tungsten93'), 'inches 50 slap')
